// extracted by mini-css-extract-plugin
module.exports = {"card":"similaireCards_card__aw6O2","title":"similaireCards_title__G0K2r","links":"similaireCards_links__x6Hiq"};